import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ReusableTable = ({ 
    columns, 
    data, 
    keyExtractor = (item) => item.id,
    pagination 
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm ring-1 ring-slate-200/60 overflow-hidden flex flex-col min-h-[400px]">
      <div className="flex-1 overflow-x-auto custom-scrollbar">
        <table className="w-full text-left border-collapse whitespace-nowrap">
          <thead>
            <tr className="bg-slate-50/80 border-b border-slate-200">
              {columns.map((col, index) => (
                <th 
                  key={col.key || index} 
                  className={`p-4 text-xs font-black text-slate-400 uppercase tracking-wider  ${col.headerClassName || ''}`}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {data.map((row, rowIndex) => (
              <tr key={keyExtractor(row)}  className="hover:bg-slate-50/50 transition-colors group cursor-default">
                {columns.map((col, colIndex) => (
                  <td 
                    key={col.key || colIndex} 
                    className={`p-4  ${col.cellClassName || ''}`}
                  >
                    {/* If a custom render function is provided, use it. Otherwise, render the raw data. */}
                    {col.render ? col.render(row, rowIndex) : row[col.dataIndex]}
                  </td>
                ))}
              </tr>
            ))}
            
            {/* Show empty state if no data */}
            {data.length === 0 && (
                <tr>
                    <td colSpan={columns.length} className="p-8 text-center text-slate-500 font-medium text-sm">
                        No data available
                    </td>
                </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Footer */}
      {pagination && (
        <div className="flex flex-col sm:flex-row items-center justify-between px-6 py-4 bg-slate-50/50 border-t border-slate-200 gap-4 mt-auto">
          <div className="text-sm font-medium text-slate-500">
            Showing <span className="font-bold text-slate-900">{pagination.indexOfFirstItem + 1}</span> to{' '}
            <span className="font-bold text-slate-900">{Math.min(pagination.indexOfLastItem, pagination.totalItems)}</span> of{' '}
            <span className="font-bold text-slate-900">{pagination.totalItems}</span> entries
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => pagination.onPageChange(pagination.currentPage - 1)}
              disabled={pagination.currentPage === 1}
              className="p-2 bg-white ring-1 ring-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-sm text-slate-600"
            >
              <ChevronLeft className="w-4 h-4" />
            </button>
            {Array.from({ length: pagination.totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => pagination.onPageChange(i + 1)}
                className={`min-w-[36px] h-9 px-2 text-sm font-bold rounded-lg transition-all ${
                  pagination.currentPage === i + 1
                    ? 'bg-slate-900 text-white shadow-md'
                    : 'bg-white text-slate-600 hover:bg-slate-50 ring-1 ring-slate-200 shadow-sm'
                }`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => pagination.onPageChange(pagination.currentPage + 1)}
              disabled={pagination.currentPage === pagination.totalPages}
              className="p-2 bg-white ring-1 ring-slate-200 rounded-lg hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-sm text-slate-600"
            >
              <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReusableTable;